import { authService } from '@/features/auth/services/authService';

const EMAIL_FORMAT_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const FORGOT_PASSWORD_MESSAGES = {
    emailRequired: 'Email address is required',
    emailInvalid: 'Please enter a valid email address (e.g., name@example.com)',
    phoneRequired: 'Phone number is required',
    phoneInvalid: 'Invalid phone number format',
    phoneNotRegistered:
        'If this phone number is registered with an account, a verification code has been sent.',
    emailNotRegistered:
        'If this email is registered with an account, a verification code has been sent.',
} as const;

export type ForgotChannel = 'email' | 'phone';

export function getForgotEmailFormatError(email: string): string | null {
    const value = email.trim();
    if (!value) return FORGOT_PASSWORD_MESSAGES.emailRequired;
    if (!EMAIL_FORMAT_REGEX.test(value)) return FORGOT_PASSWORD_MESSAGES.emailInvalid;
    return null;
}

export function getForgotPhoneFormatError(phone: string): string | null {
    const value = phone.trim();
    if (!value) return FORGOT_PASSWORD_MESSAGES.phoneRequired;
    const result = authService.validatePhone(value);
    if (!result.isValid) {
        return FORGOT_PASSWORD_MESSAGES.phoneInvalid;
    }
    return null;
}

export function isForgotContactFormatValid(channel: ForgotChannel, contact: string): boolean {
    if (channel === 'email') return getForgotEmailFormatError(contact) === null;
    return getForgotPhoneFormatError(contact) === null;
}

export function getForgotNotRegisteredMessage(channel: ForgotChannel): string {
    return channel === 'phone'
        ? FORGOT_PASSWORD_MESSAGES.phoneNotRegistered
        : FORGOT_PASSWORD_MESSAGES.emailNotRegistered;
}
